import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinbaramati() {



  const cardData =
  {
    keyword: 'Cab Service in Baramati',
    heading: 'Sanavi Travels: Cab Service in Baramati',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Baramati, providing safe, comfortable, and convenient transportation for local travel, sightseeing trips, outstation journeys, and corporate travel in and around Baramati. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free experience. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient doorstep pickup and drop across Baramati, Pune, and nearby areas, making it ideal for family outings, business trips, group travel, and religious visits. Choose Sanavi Travels for trusted cab services in Baramati, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Baramati with Sanavi Travels',


"topPlaces": [
  {
    "title": "Baramati Town",
    "description": "Baramati, located in Pune district, is an important agricultural, industrial, and cultural hub in Maharashtra. Known for its fertile land and sugarcane cultivation, the town blends rural charm with modern development. Baramati is also famous for its political significance and has produced prominent leaders. Visitors can explore the town to experience local markets, traditional lifestyle, and nearby natural attractions."
  },
  {
    "title": "Taljai Temple",
    "description": "Taljai Temple, located near Baramati, is a revered Hindu shrine dedicated to local deities. The temple is set amidst serene surroundings and attracts devotees, especially during festivals. Its peaceful environment provides an ideal spot for meditation and spiritual reflection."
  },
  {
    "title": "Koregaon Bhima Riverfront",
    "description": "The banks of the Bhima River near Baramati offer scenic views, calm waters, and lush greenery. The riverfront is popular for picnics, morning walks, and photography, especially during the monsoon season when the landscapes are vibrant and green."
  },
  {
    "title": "Baramati Sugar Factory and Mills",
    "description": "Baramati is known for its sugar industry, with several sugar factories in and around the town. Visitors interested in agriculture and industry can witness the sugar production process and learn about the region’s agrarian economy."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Baramati’s local markets are vibrant with agricultural produce, handicrafts, and traditional goods. Visitors can explore these markets to experience the local culture, purchase souvenirs, and interact with the community."
  },
  {
    "title": "Temples of Baramati Taluka",
    "description": "The Baramati region is dotted with historic temples dedicated to Lord Shiva, Lord Ganesha, and other deities. These temples reflect traditional Maharashtrian architecture and host colorful festivals and religious gatherings throughout the year."
  },
  {
    "title": "Dhom and Ujjani Dams",
    "description": "Nearby Dhom and Ujjani dams are popular destinations for nature lovers and adventure seekers. These reservoirs offer boating, fishing, birdwatching, and breathtaking sunset views, making them ideal for weekend getaways from Baramati."
  },
  {
    "title": "Baramati Hills and Trekking Spots",
    "description": "The small hills around Baramati provide trekking and hiking opportunities. Visitors can enjoy panoramic views of the farmland, villages, and natural landscapes, offering a peaceful retreat from urban life."
  },
  {
    "title": "Cultural Festivals and Fairs",
    "description": "Baramati hosts various cultural festivals, fairs, and events that showcase the region’s traditions, music, dance, and culinary heritage. These vibrant celebrations give visitors an immersive experience of rural Maharashtrian culture."
  },
  {
    "title": "Rural Tourism Experiences",
    "description": "The villages surrounding Baramati allow visitors to experience authentic rural life, traditional farming practices, and local cuisine. Participating in these activities provides insight into the day-to-day life of Maharashtra’s countryside."
  }
]
,



"services": [
{
"name": "Cab Service in Baramati",
"description": "Cab Service in Baramati provides reliable and comfortable taxi services for local travel, sightseeing, airport transfers, and outstation trips. With well-maintained vehicles, professional drivers, and timely pickups, it ensures a safe, smooth, and hassle-free journey. Ideal for families, tourists, corporate clients, and solo travelers, this service emphasizes convenience, punctuality, and a stress-free travel experience across Baramati and nearby regions."
},
{
"name": "Taxi Service Baramati",
"description": "Taxi Service Baramati offers efficient and professional cab solutions for city commuting, short trips, and planned excursions. With courteous drivers, transparent pricing, and flexible booking options, it is a trusted choice for residents, tourists, and business travelers seeking reliable and timely transportation within Baramati and surrounding areas."
},
{
"name": "AC Cab Baramati",
"description": "AC Cab Baramati provides a comfortable and refreshing travel experience with fully air-conditioned vehicles. Perfect for long-distance trips, corporate travel, family outings, and sightseeing, these cabs ensure a relaxing and smooth journey with modern interiors and a premium travel experience for all passengers."
},
{
"name": "Local Cab Baramati",
"description": "Local Cab Baramati offers quick, convenient, and affordable taxi services for city commuting, shopping trips, and local sightseeing. With professional drivers and timely pickups, it provides a dependable solution for residents and visitors needing short-distance travel within Baramati and nearby areas."
},
{
"name": "Outstation Cab Baramati",
"description": "Outstation Cab Baramati specializes in long-distance travel services to nearby cities, tourist destinations, and hill stations. Comfortable vehicles, experienced drivers, and flexible itineraries ensure a safe, convenient, and enjoyable journey for families, groups, and solo travelers exploring destinations beyond Baramati."
},
{
"name": "Affordable Cab Baramati",
"description": "Affordable Cab Baramati delivers budget-friendly taxi services without compromising on comfort or safety. Perfect for daily commuters, families, and group travelers, it combines economical pricing with well-maintained vehicles and professional drivers, making it a smart choice for cost-conscious passengers traveling in and around Baramati."
},
{
"name": "Chauffeur Driven Cab Baramati",
"description": "Chauffeur Driven Cab Baramati provides professional drivers who handle navigation, traffic, and scheduling efficiently, allowing passengers to relax throughout the journey. Ideal for VIP travel, corporate trips, family outings, and tourist excursions, it ensures a stress-free, smooth, and enjoyable travel experience."
},
{
"name": "Best Cab Service Baramati",
"description": "Best Cab Service Baramati is known for punctual pickups, clean and well-maintained vehicles, and a customer-focused approach. Suitable for airport transfers, city travel, sightseeing, and outstation trips, it guarantees safe, comfortable, and reliable taxi services for individuals, families, and corporate clients."
},
{
"name": "Tourist Cab Baramati",
"description": "Tourist Cab Baramati caters to travelers exploring Baramati and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a memorable sightseeing experience, allowing tourists to enjoy cultural sites, scenic locations, and heritage spots without worrying about logistics or navigation."
},
{
"name": "Airport Cab Baramati",
"description": "Airport Cab Baramati offers timely and convenient taxi services for airport pickups and drop-offs. Professional drivers, well-maintained vehicles, and real-time scheduling ensure passengers reach the airport on time and travel comfortably, making it a reliable choice for both domestic and international travelers."
},
{
"name": "Corporate Cab Baramati",
"description": "Corporate Cab Baramati provides professional taxi services for executives, office travel, meetings, and corporate events. With punctual pickups, experienced drivers, and clean vehicles, it ensures efficient, reliable, and stress-free transportation for business purposes in Baramati and nearby regions."
},
{
"name": "Online Cab Booking Baramati",
"description": "Online Cab Booking Baramati allows travelers to reserve cabs quickly and conveniently with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make trip planning easy, hassle-free, and convenient for tourists, corporate clients, and local commuters alike."
},
{
"name": "Family Cab Baramati",
"description": "Family Cab Baramati provides spacious, safe, and comfortable vehicles suitable for family travel. Designed to accommodate all age groups, it ensures a smooth and enjoyable journey for family outings, vacations, and day trips within Baramati and surrounding areas."
},
{
"name": "24x7 Taxi Baramati",
"description": "24x7 Taxi Baramati offers round-the-clock taxi services for emergency travel, late-night pickups, airport transfers, and unplanned trips. With reliable drivers, well-maintained vehicles, and instant availability, it ensures passengers can travel safely and comfortably at any hour of the day or night."
},
{
"name": "Baramati Travel Taxi",
"description": "Baramati Travel Taxi provides complete taxi solutions for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to residents, tourists, families, and corporate travelers seeking dependable and convenient transportation in Baramati and nearby areas."
}
],
"tableData": [
["Cab Service in Baramati", "Taxi Service Baramati"],
["AC Cab Baramati", "Local Cab Baramati"],
["Outstation Cab Baramati", "Affordable Cab Baramati"],
["Chauffeur Driven Cab Baramati", "Best Cab Service Baramati"],
["Tourist Cab Baramati", "Airport Cab Baramati"],
["Corporate Cab Baramati", "Online Cab Booking Baramati"],
["Family Cab Baramati", "24x7 Taxi Baramati"],
["Baramati Travel Taxi", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Baramati with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Baramati for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air-conditioned, and kept clean to ensure a smooth and enjoyable ride around Baramati."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Baramati routes, ensuring safe, timely, and pleasant travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Baramati, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Baramati."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Baramati?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Baramati for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Baramati?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Baramati?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Baramati.'
  },
  {
    question: 'Are the drivers experienced with routes in Baramati?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Baramati area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Baramati.'
  },
  {
    question: 'Is the cab service in Baramati available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services in Baramati to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Baramati.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Jadhav',
    feedback: 'Booked a cab in Baramati with Sanavi Travels — punctual, clean, and very professional service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Patil',
    feedback: 'Sanavi Travels provided a comfortable and safe cab ride in Baramati. Highly recommended!',
    rating: 5
  }
];















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Service in Baramati - Sanavi Travels",
  "description": "Sanavi Travels provides AC, local, and outstation cab services in Baramati for airport transfers, family travel, corporate trips, and tourist journeys. Affordable, reliable, chauffeur-driven taxi service with 24x7 online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "39"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Cab Service in Baramati | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC, local, and outstation cab services in Baramati for airport transfers, family travel, corporate trips, and tourist journeys. Affordable, reliable, chauffeur-driven taxi service with 24x7 online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/136.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinbaramati;